// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__aGZW2","left":"InfoRow_left__2yKv4"};